import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {MediaViewComponent} from "./media-view.component";
import {PipesModule} from "../../core/pipes/pipes.module";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {TranslateModule} from "@ngx-translate/core";
import {ImageSizerDirective} from "../directives/image-sizer.directive";
import {AspectRatioDirective} from "../../core/directives/aspect-ratio.directive";



@NgModule({
  declarations: [MediaViewComponent],
  exports: [
    MediaViewComponent
  ],
    imports: [
        CommonModule,
        PipesModule,
        ButtonModule,
        RippleModule,
        TranslateModule,
        NgOptimizedImage,
        ImageSizerDirective,
        AspectRatioDirective,
    ]
})
export class MediaViewModule { }
